import loadable from '@loadable/component'

const Unauthorized = loadable(() => import('~/components/Error/Unauthorized'))
const ForgetPassword = loadable(() => import('~/pages/_IDM/ForgetPassword'))
const NewPassword = loadable(() => import('~/pages/_IDM/NewPassword'))
const MFASetup = loadable(() => import('~/pages/MFASetup'))
const MFAVerify = loadable(() => import('~/pages/MFAVerify'))

const Streamax = loadable(() => import('~/modules/Streamax'))
const LoginPage = loadable(() => import('~/pages/Login'))
const DetailMapPage = loadable(() => import('~/pages/DetailMapPublic'))
const LoginNotAuthorizedPage = loadable(
  () => import('~/pages/LoginNotAuthorized')
)
const SSOLoginPage = loadable(() => import('~/pages/SSOLogin'))

export default [
  {
    id: 'login-page',
    path: '/',
    component: LoginPage,
  },
  {
    id: 'sso-login-page',
    path: '/sso/login',
    component: SSOLoginPage,
  },
  {
    id: 'sso-login-authorized',
    path: '/not-authorized',
    component: LoginNotAuthorizedPage,
  },
  {
    id: 'unauthorized',
    path: '/not-authorized',
    component: Unauthorized,
  },
  {
    id: 'public-map',
    path: '/public-map',
    component: DetailMapPage,
  },
  {
    id: 'forget-password',
    path: '/forget-password',
    component: ForgetPassword,
  },
  {
    id: 'new-password',
    path: '/new-password',
    component: NewPassword,
  },
  {
    id: 'mfa-setup',
    path: '/mfa-setup',
    component: MFASetup,
  },
  {
    id: 'mfa-verify',
    path: '/mfa-verify',
    component: MFAVerify,
  },
  {
    id: 'streamax',
    path: '/streamax/:id',
    component: Streamax,
  },
]
